export const environment = {
    production: false,
    claimEndpoint: "https://mpcv-api.claims.test.c1.statefarm/mpcv/claims/",
    policyEndpoint: "https://mpcv-api.claims.test.c1.statefarm/mpcv/claims",
    userEndpoint: "https://mpcv-api.claims.test.c1.statefarm/mpcv/user",
    b2bHome: "https://b2b.tcidv.statefarm.com/b2b-content"
};
